// ib-ahrens-gmbh.de — Haupt-Bundle.
// Sammelt NUR ein (keine Logik in dieser Datei).
// Build:  npm run build:js  ->  theme/public/js/main.js

// Bootstrap-Plugins modular — nur die tatsächlich genutzten (§6).
// Side-Effect-Import registriert die data-bs-* Data-API.
import "bootstrap/js/dist/offcanvas"; // Navbar (mobil)
import "bootstrap/js/dist/collapse"; // Akkordeon, Leistungs-Cards, Cookie-Consent

import { initNavbar } from "./modules/navbar.js";
import { initHScroll } from "./modules/hscroll.js";
import { initFilters } from "./modules/filter.js";
import { initRefFilter } from "./modules/reffilter.js";
import { initLeistungsCards } from "./modules/leistungscards.js";
import { initBgVideo } from "./modules/video.js";
import { initReveal } from "./modules/reveal.js";
import { initKarte } from "./modules/karte.js";
import { initRefSlider } from "./modules/refslider.js";
import { initRefheaderMark } from "./modules/refheader-mark.js";

document.addEventListener("DOMContentLoaded", () => {
  initNavbar();
  initHScroll();
  initFilters();
  initRefFilter();
  initLeistungsCards();
  initBgVideo();
  initReveal();
  initKarte();
  initRefSlider();
  initRefheaderMark();
});
